"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatGroceryItemsToCopy = void 0;
exports.formatGroceryItemsToCopy = (groceryItems) => {
    let text = "";
    groceryItems.forEach((item, i) => {
        if (!i) {
            return;
        }
        if ("title" in item) {
            return;
        }
        if ("groupKeyword" in item) {
            return;
        }
        const parts = [];
        if (item.amount) {
            parts.push(item.amount);
        }
        if (item.unit) {
            parts.push(item.unit);
        }
        const lastPart = item.name || item.keyword;
        if (lastPart) {
            parts.push(lastPart);
        }
        text += parts.join(" ") + "\n";
    });
    return text;
};
//# sourceMappingURL=formatGroceryItemsToCopy.js.map